import { Link } from "react-router-dom";

// Primary Nofina Movie horizontal brand mark (webp, served locally).
// Navy background blends into the dark header; no circle/badge/container.
export function BrandLogo({
  className = "h-[56px] sm:h-[88px]",
  testId = "nav-brand-logo",
}) {
  return (
    <Link
      to="/"
      data-testid={testId}
      aria-label="Nofina Movie, ke beranda"
      className="inline-flex items-center rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-nm-red focus-visible:ring-offset-2 focus-visible:ring-offset-nm-bg"
    >
      <img
        src="/brand/nofina-movie-wordmark-v2.png?v=3"
        alt="Nofina Movie"
        className={`${className} w-auto object-contain`}
      />
    </Link>
  );
}
